const seoPage = {
  subtitle: 'Vous pouvez définir votre méta-titre et description SEO.',
}

export default seoPage
